import * as React from "react";
import classnames from "classnames";
import { Carousel } from "@grandvisionhq/common";
import { UspGroupItem } from "./UspGroupItem.js";
/* empty css              */
const UspGroup = ({ items = [], theme = "light" }) => {
  if (!items.length) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classnames("usp-group", {
        "usp-group--light": theme === "light"
      }),
      "data-t": "usp-group"
    },
    /* @__PURE__ */ React.createElement("div", { className: "usp-group__container desktop-hidden" }, /* @__PURE__ */ React.createElement(Carousel, { hasInverseColor: theme !== "light" }, items.map((item) => /* @__PURE__ */ React.createElement(UspGroupItem, { item, key: item.text })))),
    /* @__PURE__ */ React.createElement("ul", { className: "usp-group__container mobile-hidden" }, items.map((item) => /* @__PURE__ */ React.createElement(UspGroupItem, { item, key: item.text, renderAsListItem: true })))
  );
};
export {
  UspGroup,
  UspGroup as default
};
//# sourceMappingURL=UspGroup.js.map
